import { Component, OnInit, EventEmitter, Output, ViewContainerRef, ViewChild, AfterViewInit, ElementRef } from "@angular/core";
import { DropdownValue } from "../shared/dropdown.model";
import { ProviderTreeSelectionModalComponent } from "../shared/providers-tree-selection-modal.component";
import { TreeSelectionModel } from "../shared/tree-selection.model";
import { FilterItemsService } from "../reports";

@Component({
    selector: 'publisher-mappings-modal-form',
    moduleId: module.id,
    templateUrl: 'publisher-mappings-form-modal.component.html'
})

export class PublisherMappingsFormComponent implements OnInit, AfterViewInit {
    public countryValues: Array<DropdownValue> = [];
    public countryPrefix: string = "Country";
    @ViewChild("providerTreeSelectionModal") providerTreeSelectionModalComponent: ProviderTreeSelectionModalComponent
    selectedCountry: number = 0;
    selectedProvidersInOrder: number[];
    values: Array<TreeSelectionModel> = new Array<TreeSelectionModel>();
    sectionOpen: boolean = true;

    //contains the country id of the mapping that needs to be removed from the parent
    @Output()
    public removedPublisherMappings: EventEmitter<number> = new EventEmitter<number>();

    constructor(public viewContainerRef: ViewContainerRef, private elRef: ElementRef) { }

    ngOnInit(): void {
        this.selectedProvidersInOrder = new Array<number>();
    }

    ngAfterViewInit() {
        let q = this.elRef.nativeElement.querySelector('select');
        $(q).treeMultiselect({ enableSelectAll: true, sortable: false });
    }

    public onCountryValueChanged(item: DropdownValue) {
        this.selectedCountry = item.value;
    }

    public onProvidersSelected() {
        let selectedElements = this.elRef.nativeElement.querySelectorAll('.tree-multiselect .selected div.item');
        this.selectedProvidersInOrder = [];
        selectedElements.forEach(element => {
            this.selectedProvidersInOrder.push($(element).data().value);
        });
    }

    onCountryClicked(event) {
        $(".configurable-dropdown .list")
            .css("left", function () {
                return $(this).parent().position().left;
            })
            .css("top", function () {
                return $(this).parent().position().top;
            }).css('position', 'fixed');
    }

    removeSection() {
        this.removedPublisherMappings.emit(this.selectedCountry);
    }

    toggleSection() {
        event.preventDefault();
        this.sectionOpen = !this.sectionOpen;
        var btn = this.elRef.nativeElement.querySelector('.ctrl-collapse');
        var svgButton = $(btn).find("svg");
        $(svgButton).toggleClass("turned");
    }
}


// WEBPACK FOOTER //
// ./src/app/publishers/publisher-mappings-form-modal.component.ts